var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__statistiky"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4453",
    x: 3,
    y: 15,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4454",
    x: 10,
    y: 9,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4455",
    d: "M17,3h4v18h-4V3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.8173bd9e022da0c422672a04df9a1290.svg";
export { ForwardRef as ReactComponent };